import {ErrorFLKModel} from "@amlCore/models";

/**
 * Модель ошибок ФЛК в таблиах для передачи между компонентами
 */
export interface ErrorTableFLKModel {
  error: ErrorFLKModel; // Ошибка по полю в таблице
  tableError: ErrorFLKModel; // Ошибки по таблице
}
